App.vue.setComponent(require('@components/News/News').default);
App.vue.setComponent(require('@components/FortuneWheel/FortuneWheel').default);
App.vue.setComponent(require('@components/sliders/NewGoods').default);
